import utils from './utils';

let form;

export default form = {
  submit: ((variables) => {
    variables.component.$refs[variables.component.form_name].validate((valid) => {
      if (valid) {
        utils.reassign(variables.component, 'loading', true);
        variables.next();
      }
    });
  }),
  reset: ((component) => {
    component.$refs[component.form_name].resetFields();
  }),
  confirm: ((content, events, variables) => {
    variables.component.$confirm(content.message, content.title, {
      confirmButtonText: content.confirmText,
      cancelButtonText: content.cancelText,
    }).then(() => {
      events.confirmFunc(variables);
    }).catch(() => {
      events.cancelFunc(variables);
    });
  }),
  error: ((variables) => {
    variables.component.$notify.error({
      title: 'Error',
      message: `Hubo un error: ${variables.message.error}`,
      duration: 0,
    });
    form.reset(variables.component);
    utils.reassign(variables.component, 'loading', false);
  }),
  success: ((variables, reset) => {
    variables.component.$notify({
      title: 'Éxito',
      message: `${variables.message.success} con éxito`,
      type: 'success',
      duration: 0,
    });
    if (reset) {
      form.reset(variables.component);
      utils.reassign(variables.component, 'loading', false);
    }
  }),
  receive: ((id, component, tag) => {
    if (component[tag] === undefined) {
      const tempObj = utils.reassign(component.form, tag, id);
      utils.reassign(component, 'form', tempObj);
    } else {
      utils.reassign(component, tag, id);
    }
  }),
};
